(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MarketingCampaign', MarketingCampaign);

    MarketingCampaign.$inject = ['$resource', 'DateUtils'];

    function MarketingCampaign($resource, DateUtils) {
        var resourceUrl = 'api/marketing-campaign/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
